import React, { Fragment, useState } from "react"
import { useSelector } from "react-redux"
import { FaBars } from "react-icons/fa"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import {
  KitchenTableLevels,
  KitchenTablesLegend
} from "components"
import KtBox from "./KtBox"
import KtSidebar from "./KtSidebar"
import classes from "./index.module.scss"

const KitchenTables = () => {
  const i18n = useTranslation()[1]

  const availableTables =
    useSelector(state =>
      state.kitchenTables.filter(t => t.available)
    )

  const initialSelectedLevelState =
    availableTables[0]?.level || ""

  const [tableOrders, setTableOrders] = useState(null)
  const [selectedOrders, setSelectedOrders] = useState({})
  const [selectedTableId, setSelectedTableId] = useState(null)
  const [openTableSidebar, setOpenTableSidebar] = useState(false)
  const [selectedFloor, setSelectedFloor] = useState(initialSelectedLevelState)
  const [showMoveTableMessage, setShowMoveTableMessage] = useState(false)

  const thisLevelTables =
    availableTables.filter(t =>
      t.level === selectedFloor
    )

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <KtSidebar
        tableOrders={tableOrders}
        setTableOrders={setTableOrders}
        selectedTableId={selectedTableId}
        selectedOrders={selectedOrders}
        setSelectedOrders={setSelectedOrders}
        showMoveTableMessage={showMoveTableMessage}
        setShowMoveTableMessage={setShowMoveTableMessage}
        openTableSidebar={openTableSidebar}
        setOpenTableSidebar={setOpenTableSidebar}
      />

      <div
        className={clsx(
          classes["right"],
          isLtr && classes["right-ltr"]
        )}
      >
        <div className={classes["legend-container"]}>
          <button
            id="table-hamburger-button"
            className={classes["button"]}
            onClick={() => setOpenTableSidebar(prev => !prev)}
          >
            <FaBars
              size={20}
              color="white"
            />
          </button>

          <KitchenTablesLegend />
        </div>

        <KitchenTableLevels
          tables={availableTables}
          selectedFloor={selectedFloor}
          setSelectedFloor={setSelectedFloor}
        />

        <div
          id="tables-container"
          className={classes["boxes"]}
        >
          {thisLevelTables.map(table =>
            <KtBox
              key={table._id}
              table={table}
              setSelectedTableId={setSelectedTableId}
              setTableOrders={setTableOrders}
              selectedOrders={selectedOrders}
              setSelectedOrders={setSelectedOrders}
              showMoveTableMessage={showMoveTableMessage}
              setShowMoveTableMessage={setShowMoveTableMessage}
              setOpenTableSidebar={setOpenTableSidebar}
            />
          )}
        </div>
      </div>
    </Fragment>
  )
}

export default KitchenTables